<app-popup
  [heading]="'Email Detail'"
  [showCloseIcon]="true"
  [showFooterButtons]="false"
  (cancelClicked)="closePopup()"
>
  <div class="email-detail-content">
    @if (loading) {
      <div class="state-container loading-container">
        <div class="spinner"></div>
        <p>Loading email details...</p>
      </div>
    } @else if (errorMessage) {
      <div class="state-container error-container">
        <p>{{ errorMessage }}</p>
        <button class="retry-button" (click)="loadEmailDetail()">Retry</button>
      </div>
    } @else if (emailDetail) {
      <div class="email-meta-card">
        <div class="meta-row meta-row-top">
          <div class="meta-pill subject-pill">
            <span class="pill-label">Subject:</span>
            <span
              class="pill-value subject-value"
              [title]="emailDetail.subject || ''"
            >
              {{ emailDetail.subject || "(No Subject)" }}
            </span>
          </div>

          <div class="meta-pill sent-pill">
            <span class="pill-label">Sent Date:</span>
            <span class="pill-value">
              {{
                emailDetail.sent_at
                  ? (emailDetail.sent_at | date: "medium")
                  : "—"
              }}
            </span>
          </div>
        </div>

        <div class="meta-row meta-row-bottom">
          <div class="meta-pill">
            <span class="pill-label">To:</span>
            <span
              class="pill-value highlight"
              [title]="emailDetail.recipient_email || ''"
            >
              {{ emailDetail.recipient_email || "—" }}
            </span>
          </div>

          <div class="meta-divider"></div>

          <div class="meta-pill">
            <span class="pill-label">Context:</span>
            <span class="context-badge">
              {{ formatContext(emailDetail.email_context) }}
            </span>
          </div>

          <div class="meta-divider"></div>

          <div class="meta-pill">
            <span class="pill-label">Ref ID:</span>
            <span class="pill-value font-mono">{{
              emailDetail.reference_id
            }}</span>
          </div>

          @if (emailDetail.correlation_id) {
            <div class="meta-divider"></div>

            <div class="meta-pill">
              <span class="pill-label">Correlation ID:</span>
              <span
                class="pill-value font-mono"
                [title]="emailDetail.correlation_id"
              >
                {{ emailDetail.correlation_id }}
              </span>
              <button
                type="button"
                class="copy-id-btn"
                (click)="copyCorrelationId(emailDetail.correlation_id)"
                [title]="
                  copiedCorrelationId ? 'Copied!' : 'Copy Correlation ID'
                "
              >
                @if (copiedCorrelationId) {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#16a34a"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                } @else {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <rect
                      x="9"
                      y="9"
                      width="13"
                      height="13"
                      rx="2"
                      ry="2"
                    ></rect>
                    <path
                      d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                    ></path>
                  </svg>
                }
              </button>
            </div>
          }
        </div>
      </div>

      <section class="body-section">
        <div class="body-header">
          <h3>Email Body</h3>
          @if (emailDetail.body) {
            <button
              type="button"
              class="body-open-tab-btn"
              (click)="openInNewTab()"
              title="Open email in new tab"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="14"
                height="14"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                ></path>
                <polyline points="15 3 21 3 21 9"></polyline>
                <line x1="10" y1="14" x2="21" y2="3"></line>
              </svg>
              <span>Open in New Tab</span>
            </button>
          }
        </div>
        @if (emailDetail.body && safeBody) {
          <iframe
            class="email-body-frame"
            [srcdoc]="safeBody"
            sandbox=""
            title="Email body preview"
          ></iframe>
        } @else {
          <div class="no-body">
            <p>No email body stored for this message.</p>
          </div>
        }
      </section>
    }
  </div>
</app-popup>
